<!--
// Copyright © 2026 TraceX SAS
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
-->
<script lang="ts">
  import { themeStore } from '@hcengineering/theme'

  // @ts-ignore -- Webpack's file-loader provides the image module at runtime.
  import logoWhite from '../../img/tracex-logo-white.png'
  // @ts-ignore -- Webpack's file-loader provides the image module at runtime.
  import logoBlack from '../../img/tracex-logo-black.png'

  export let height: string = '2rem'

  $: src = $themeStore.dark ? logoWhite : logoBlack
</script>

<img class="tracex-logo" {src} alt="TraceX" style:height />

<style lang="scss">
  .tracex-logo {
    display: block;
    width: auto;
  }
</style>
